import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { SurveyViewShared } from '../../components/PublicSurveys/SurveyViewShared';

export const SurveyPreviewView: React.FC = () => {
  const { surveyId } = useParams<{ surveyId: string }>();
  const pok = usePokCore();

  const fetchSurvey = useCallback(
    (id: string) => pok.surveys.preview(id),
    [pok.surveys],
  );

  return (
    <SurveyViewShared
      identifier={surveyId}
      fetchSurvey={fetchSurvey}
      isPreview={true}
    />
  );
};
